@if (tips().length === 1) {
  <app-reduction-tip-item [tip]="tips()[0]" />
} @else {
  <div class="rounded-lg transition-colors">
    <!-- Group header -->
    <div class="flex items-center gap-2 border-b border-primary-100 px-3 py-2">
      @if (selectable()) {
        <p-checkbox
          [binary]="true"
          [ngModel]="allSelected()"
          [indeterminate]="partiallySelected()"
          (onChange)="onToggleAll()"
          [inputId]="'tip-group-' + group().type"
          [ariaLabel]="i18nKey() + '.titlePlural' | transloco"
        />
      } @else {
        <span class="w-5 shrink-0"></span>
      }

      <button
        type="button"
        class="flex min-w-0 flex-1 items-center gap-3 text-left"
        [attr.aria-expanded]="expanded()"
        (click)="toggleExpanded()"
      >
        <div
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-200"
        >
          <lucide-icon [name]="icon()" [size]="16" class="text-primary-500" />
        </div>

        <span class="min-w-0 flex-1">
          <span
            class="block truncate text-paragraph-s-reg font-medium text-primary-900"
          >
            {{ i18nKey() + ".titlePlural" | transloco }}
          </span>
          <span class="block text-paragraph-xs-reg text-greyscale-600">
            @if (selectedCount() > 0) {
              {{
                "reductionTips.group.selectedCount"
                  | transloco
                    : { selected: selectedCount(), count: tips().length }
              }}
            } @else {
              {{
                "reductionTips.group.count"
                  | transloco: { count: tips().length }
              }}
            }
          </span>
        </span>

        <!-- Same shortfall badge as a standalone tip: the group gathers tips
             of one type, so a committed one is a commitment this trip breaks. -->
        @if (isCommitted()) {
          <span
            class="flex shrink-0 items-center gap-1 rounded-full bg-warning-100 px-2 py-0.5 text-paragraph-xs-reg font-medium text-warning-700"
            [pTooltip]="
              'reductionTips.commitments.unmetBadgeTooltip' | transloco
            "
            tooltipPosition="top"
          >
            <lucide-icon name="triangle-alert" [size]="12" />
            {{ "reductionTips.commitments.unmetBadge" | transloco }}
          </span>
        }

        @if (selectable()) {
          <span
            class="shrink-0 text-paragraph-s-reg font-semibold tabular-nums text-validation-600"
          >
            −{{ displaySavings() | formatCO2e }}
          </span>
        } @else {
          <span class="shrink-0 text-paragraph-xs-reg text-greyscale-500">
            {{ "reductionTips.informational" | transloco }}
          </span>
        }

        <lucide-icon
          name="chevron-down"
          [size]="16"
          class="shrink-0 text-greyscale-500 transition-transform"
          [class.rotate-180]="expanded()"
        />
      </button>
    </div>

    <!-- One row per trip element -->
    @if (expanded()) {
      <ul class="space-y-2 px-3 py-2">
        @for (tip of tips(); track tip.id) {
          <li>
            <app-reduction-tip-item [tip]="tip" [nested]="true" />
          </li>
        }
      </ul>
    }
  </div>
}
